/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseServiceContractV1Dto } from './BaseServiceContractV1Dto';
import type { ServiceObjectMaintenanceEntryV1Dto } from './ServiceObjectMaintenanceEntryV1Dto';
export type ServiceObjectStatusV1Dto = {
  /**
   * The unique identifier of the entity.
   */
  readonly id: string;
  /**
   * The date when the entity was created.
   */
  readonly createdAt: string;
  /**
   * The date when the entity was modified.
   */
  readonly modifiedAt: string;
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * Interval for maintenance in combination with intervalUnit
   */
  interval: number;
  /**
   * Unit of the maintenance interval
   */
  intervalUnit: ServiceObjectStatusV1Dto.intervalUnit;
  /**
   * Cost of the last maintenance
   */
  lastCost?: number;
  /**
   * Date of the last maintenance
   */
  lastPerformedDate?: string;
  /**
   * Date of the next maintenance
   */
  nextDueDate?: string;
  /**
   * Notice period for the maintenance
   */
  notice: number;
  /**
   * ID of the service object associated with the maintenance status
   */
  objectId: string;
  /**
   * Type of this status (e.g. Maintenance, Inspection)
   */
  type: ServiceObjectStatusV1Dto.type;
  /**
   * Name of the service object status
   */
  name?: string;
  /**
   * Contract associated with the maintenance status
   */
  contract: BaseServiceContractV1Dto;
  /**
   * Maintenance entries associated with the maintenance status
   */
  maintenanceEntries: Array<ServiceObjectMaintenanceEntryV1Dto>;
};
export namespace ServiceObjectStatusV1Dto {
  /**
   * Unit of the maintenance interval
   */
  export enum intervalUnit {
    DAY = 'Day',
    WEEK = 'Week',
    MONTH = 'Month',
    YEAR = 'Year',
  }
  /**
   * Type of this status (e.g. Maintenance, Inspection)
   */
  export enum type {
    MAINTENANCE = 'Maintenance',
    INSPECTION = 'Inspection',
  }
}
